import { render, staticRenderFns } from "./TrainingExerciseFormDialog.vue?vue&type=template&id=5bcce3a2"
import script from "./TrainingExerciseFormDialog.vue?vue&type=script&lang=js"
export * from "./TrainingExerciseFormDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports